module.exports = __webpack_public_path__ + "static/media/Google.095cb58d.svg";